module.exports = __webpack_public_path__ + "img/icon-1.a6c5e218.png";